import { RootState } from "integrations/redux"
import { missionsTableSliceName } from "./missions-table-slice"

const root = (state: RootState) => state[missionsTableSliceName]

export const selectSelectedMissionIds = (state: RootState) => root(state).selectedMissionIds
export const selectRenamingGroupId = (state: RootState) => root(state).renamingGroupId
export const selectHoveredRowId = (state: RootState) => root(state).hoveredRowId
export const selectTagDropdownFlightId = (state: RootState) => root(state).tagDropdownFlightId
export const selectOpenProjectDropdownFlightId = (state: RootState) =>
    root(state).openProjectDropdownFlightId
export const selectFlightsSearch = (state: RootState) => root(state).search
export const selectFlightsPage = (state: RootState) => root(state).page
export const selectChecklistFilter = (state: RootState) => root(state).checklistFilter
export const selectSortState = (state: RootState) => root(state).sortState
export const selectDateFilter = (state: RootState) => root(state).dateFilter
export const selectPilotFilter = (state: RootState) => root(state).pilotFilter
export const selectDroneFilter = (state: RootState) => root(state).droneFilter
export const selectTagFilter = (state: RootState) => root(state).tagFilter
